import { Message } from "element-ui";
import { isMobile } from "@saas/components";
// 全局设置 elementUI的$message的默认显示时间
export let customMessage = (options) => {
  let defaultOptions = {
    duration: 1800,
    offset: 80,
  };
  if (typeof options === "string") {
    Message({
      customClass: isMobile() ? "message-mobile" : "message-pc",
      ...defaultOptions,
      message: options,
    });
  } else {
    Message({
      customClass: isMobile() ? "message-mobile" : "message-pc",
      ...defaultOptions,
      ...options,
    });
  }
};

["error", "success", "info", "warning"].forEach((type) => {
  let defaultOptions = {
    duration: 1800,
    offset: 80,
  };
  customMessage[type] = (options) => {
    if (typeof options === "string") {
      Message({
        type: type,
        customClass: isMobile() ? "message-mobile" : "message-pc",
        ...defaultOptions,
        message: options,
      });
    } else {
      Message({
        type: type,
        customClass: isMobile() ? "message-mobile" : "message-pc",
        ...defaultOptions,
        ...options,
      });
    }
  };
});
